import {
    SPENDINGCONTROL,
    SPENDINGCONTROL_SET_SUCCESS,
    SPENDINGCONTROL_SET_TRIGGER
} from "../actionType";


const INITIAL_STATE = {

};

const spendingcontrol = (state = INITIAL_STATE, action) => {
    
    switch (action.type) {
        case SPENDINGCONTROL:
            return {
                ...state,
            };

        case SPENDINGCONTROL_SET_TRIGGER:
            return action.payload;
        case SPENDINGCONTROL_SET_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};
export default spendingcontrol;